import styled from "@emotion/styled";

export const CustomMapContent = styled.div`
  border-top: 1px solid var(--mb-color-border);
  padding: 0.75rem 1.5rem;
  justify-content: space-between;
  color: var(--mb-color-text-dark);
  font-weight: 700;
  display: flex;
`;
